/*
 * @Descripttion: 订单关怀涉及到的常量
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
export default {
  taskType: {
    xdgh: {
      label: '下单关怀',
      realKey: 'S_XDGH',
      desc1: '已下单的订单',
      desc2: '其中货到付款的订单',
    },
    ddcf: {
      label: '订单催付',
      realKey: 'S_DDCF',
      desc1: '可催付的订单',
      desc2: '其中货到付款的订单',
    },
    yscf: {
      label: '预售催付',
      realKey: 'S_YSCF',
      desc1: '可催付定金的订单',
      desc2: '可催付尾金的订单',
    },
    fkgh: {
      label: '付款关怀',
      realKey: 'S_FKGH',
      desc1: '已付款的订单',
    },
    qxdd: {
      label: '取消订单',
      realKey: 'S_QXDD',
      desc1: '已取消的订单',
      desc2: '其中货到付款的订单',
    },
    sjfh: {
      label: '商家发货',
      realKey: 'S_SJFH',
      desc1: '商家已发货的订单',
    },
    ycfh: {
      label: '延迟发货',
      realKey: 'S_YCFH',
      desc1: '超时未发货的订单',
    },
    wlfh: {
      label: '物流发货',
      realKey: 'S_WLFH',
      desc1: '物流已揽收的订单',
    },
    wlyc: {
      label: '物流异常',
      realKey: 'S_WLYC',
      desc1: '物流异常的订单',
    },
    tctx: {
      label: '同城提醒',
      realKey: 'S_TCTX',
      desc1: '到达同城的订单',
    },
    pjtx: {
      label: '派件提醒',
      realKey: 'S_PJTX',
      desc1: '派件中的订单',
    },
    qjtx: {
      label: '取件提醒',
      realKey: 'S_QJTX',
      desc1: '待取件的订单',
    },
    zltx: {
      label: '滞留提醒',
      realKey: 'S_ZLTX',
      desc1: '快递已滞留的订单',
    },
    qsgh: {
      label: '签收关怀',
      realKey: 'S_QSGH',
      desc1: '已签收的订单',
    },
    wctx: {
      label: '完成提醒',
      realKey: 'S_WCTX',
      desc1: '已完成的订单',
    },
    ddcp: {
      label: '订单催评',
      realKey: 'S_DDCP',
      desc1: '未评价的订单',
    },
    shsq: {
      label: '售后申请',
      realKey: 'S_SHSQ',
      desc1: '申请售后的订单',
    },
    jjsh: {
      label: '拒绝售后',
      realKey: 'S_JJSH',
      desc1: '商家拒绝售后的订单',
    },
    tysh: {
      label: '同意售后',
      realKey: 'S_TYSH',
      desc1: '商家同意售后的订单',
    },
    shcg: {
      label: '售后成功',
      realKey: 'S_SHCG',
      desc1: '已完成售后的订单',
    }
  },
  taskStatus: [
    {
      label: '全部',
      value: ''
    },
    {
      label: '开启',
      value: '1'
    },
    {
      label: '关闭',
      value: '0'
    },
  ]
}
